export const apiExecutionOptions = [
  { value: "priority", label: "Priority" },
  // { value: 'weight', label: 'Weight' },
  { value: "least cost", label: "Least Cost" },
];

export const productTypeOptions = [
  { value: "cards", label: "Cards" },
  { value: "phone-refill", label: "Phone Refill" },
];

export const priceTypeOptions = [
  { value: "fixed", label: "Fixed" },
  { value: "range", label: "Range" },
];

export const stockOptions = [
  { value: "true", label: "In stock" },
  { value: "false", label: "Out of stock" },
];

export const statusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "InActive" },
];
export const denominationStatusOptions = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "InActive" },
];

export const getDate = new Date();
